import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { useParams } from 'react-router-dom'
import { FaEdit, FaStore, FaChartLine, FaCheck, FaTimes } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import CardService from "../../../services/card_services"
import BusinessService from "../../../services/business_services"

export function withRouter(Children) {
    return (props) => {
        const match = { params: useParams() };
        return <Children {...props} match={match} />
    }
}

class AdminBudDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            processing: false,
            success: false,
            levels: [],
            bud_uuid: null,
            level: null,
            bud_name: null,
            description: '',
            img_url: null,
            sale_info: null,
            collection: null,
            business_uuid: null,
            businesses: [],
            target: null,
            nb_cards: 0,
        }
    }

    componentDidMount = async () => {
        await this.loadBudData()
        const levels = await CardService.getLevels()
        this.setState({ levels })
        const businesses = await BusinessService.businesses(false, true)
        this.setState({ businesses })
    }

    loadBudData = async () => {
        const { id } = this.props.match.params
        const queryParams = new URLSearchParams(window.location.search)
        const deactivated = queryParams.get("deactivated") || false
        const buds = await CardService.getBuds(deactivated)
        for (let bud of buds) {
            if (bud.bud_uuid === id) {
                console.log(bud.sale_info)
                this.setState({ level: bud.bud_level, level_max: bud.level_max, bud_name: bud.bud_name, description: bud.description, img_url: bud.img_url, bud_uuid: id, sale_info: bud.sale_info, target: bud.target, nb_cards: bud.nb_cards })
                if (bud.collection_uuid) {
                    const collections = await CardService.getCollections()
                    for (let collection of collections) {
                        if (collection.collection_uuid === bud.collection_uuid)
                            this.setState({ collection })
                    }
                }
                break
            }
        }
    }

    assignBud = async () => {
        if (!this.state.business_uuid)
            NotificationManager.error(`Please select a business`)
        else if (window.confirm("Do you confirm business affiliation?")) {
            this.setState({ processing: true })
            await BusinessService.businessBud(this.state.business_uuid, this.state.bud_uuid)
            NotificationManager.success(`Assignation successfull`)
            this.setState({ processing: false })
        }
    }

    toggleSaleStatus = async (sale) => {
        const newStatus = !sale.sale_status
        const action = newStatus ? 'activate' : 'deactivate'
        if (window.confirm(`Do you want to ${action} this sale?`)) {
            try {
                await CardService.updateBudSale(
                    sale.bud_sale_uuid,
                    sale.price,
                    sale.max_sales,
                    sale.start_sale,
                    sale.end_sale,
                    newStatus,
                    sale.xp
                )
                NotificationManager.success(`Sale ${action}d successfully`)
                // Reload the bud data to refresh sales history
                await this.loadBudData()
            } catch (e) {
                NotificationManager.error('Failed to update sale status')
            }
        }
    }

    render() {
        const levelColors = {
            starter: "bg-gray-100 text-gray-700",
            common: "bg-green-100 text-green-700",
            rare: "bg-blue-100 text-blue-700",
            epic: "bg-purple-100 text-purple-700",
            legendary: "bg-orange-100 text-orange-700",
            mythic: "bg-red-100 text-red-700",
            eternal: "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
        };

        return (
            <>
                <AdminLayout 
                    title="Bud Details"
                    breadcrumbs={[
                        { label: 'Buds', href: '/admin/buds' },
                        { label: 'Details' }
                    ]}
                >
                    <div className="max-w-6xl mx-auto space-y-6">
                        {/* Bud Overview Card */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                            <div className="grid md:grid-cols-2 gap-6 p-6">
                                {/* Image Section */}
                                <div className="flex justify-center items-start">
                                    {this.state.img_url && (
                                        <img 
                                            src={this.state.img_url} 
                                            alt={this.state.bud_name} 
                                            className="max-w-sm rounded-xl shadow-lg border-2 border-gray-300"
                                        />
                                    )}
                                </div>

                                {/* Details Section */}
                                <div className="space-y-4">
                                    <div>
                                        <h2 className="text-3xl font-bold text-gray-900 mb-3">{this.state.bud_name}</h2>
                                        <div className="flex flex-wrap gap-2 mb-4">
                                            <span className={`px-3 py-1 rounded-lg text-sm font-bold ${levelColors[this.state.level]}`}>
                                                {this.state.level}
                                            </span>
                                            {this.state.level_max && (
                                                <span className={`px-3 py-1 rounded-lg text-sm font-bold ${levelColors[this.state.level_max]}`}>
                                                    MAX: {this.state.level_max}
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="space-y-3 bg-gray-50 rounded-lg p-4">
                                        <div className="flex justify-between items-center border-b border-gray-200 pb-2">
                                            <span className="text-sm font-medium text-gray-600">Collection</span>
                                            <span className="text-sm font-semibold text-gray-900">
                                                {this.state.collection ? this.state.collection.collection_name : '-'}
                                            </span>
                                        </div>
                                        <div className="flex justify-between items-center border-b border-gray-200 pb-2">
                                            <span className="text-sm font-medium text-gray-600">Distributed</span>
                                            <span className="text-sm font-semibold text-gray-900">{this.state.nb_cards}</span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm font-medium text-gray-600">Target</span>
                                            <span className="text-sm font-semibold text-gray-900 capitalize">{this.state.target}</span>
                                        </div>
                                    </div>

                                    {/* Descriptions */}
                                    <div className="space-y-2">
                                        {this.state.description.en && (
                                            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                                                <p className="text-xs font-semibold text-blue-700 mb-1">Description (EN)</p>
                                                <p className="text-sm text-gray-800">{this.state.description.en}</p>
                                            </div>
                                        )}
                                        {this.state.description.fr && (
                                            <div className="bg-purple-50 border border-purple-200 rounded-lg p-3">
                                                <p className="text-xs font-semibold text-purple-700 mb-1">Description (FR)</p>
                                                <p className="text-sm text-gray-800">{this.state.description.fr}</p>
                                            </div>
                                        )}
                                        {!this.state.description.en && (
                                            <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
                                                <p className="text-xs font-semibold text-gray-700 mb-1">Description (Old Format)</p>
                                                <p className="text-sm text-gray-800">{this.state.description}</p>
                                            </div>
                                        )}
                                    </div>

                                    <button 
                                        onClick={() => window.location.href = `/admin/buds/update/${this.state.bud_uuid}`}
                                        className="w-full px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                                    >
                                        <FaEdit />
                                        Update Bud
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Business Assignment Section */}
                        {this.state.target === "business" && (
                            <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                                <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                                    <FaStore className="text-purple-500" />
                                    Assign Bud to Business
                                </h3>
                                <div className="max-w-md space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Select Business</label>
                                        <select 
                                            onChange={(e) => this.setState({ business_uuid: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none"
                                            defaultValue=""
                                        >
                                            <option value="" disabled>Select a business</option>
                                            {this.state.businesses.map(business =>
                                                <option key={business.business_uuid} value={business.business_uuid}>
                                                    {business.business_name}
                                                </option>
                                            )}
                                        </select>
                                    </div>
                                    {this.state.processing ? (
                                        <div className="px-4 py-2 bg-gray-100 text-gray-500 rounded-lg text-center">
                                            Processing...
                                        </div>
                                    ) : (
                                        <button 
                                            onClick={this.assignBud}
                                            className="w-full px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all font-medium shadow-md hover:shadow-lg"
                                        >
                                            Assign Bud
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* Sales Section */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                                <FaChartLine className="text-green-500" />
                                Sales History
                            </h3>

                            {this.state.sale_info && this.state.sale_info.length > 0 ? (
                                <div className="overflow-x-auto mb-4">
                                    <table className="w-full">
                                        <thead className="bg-gradient-to-r from-gray-50 to-slate-100 border-b border-gray-200">
                                            <tr>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">#</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Price</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Status</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Start Date</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">End Date</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Max Sales</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Sold</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Target</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">XP</th>
                                                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200">
                                            {this.state.sale_info.map((sale, index) => (
                                                <tr key={sale.bud_sale_uuid} className="hover:bg-gray-50 transition-colors">
                                                    <td className="px-4 py-3 text-sm text-gray-700">{index + 1}</td>
                                                    <td className="px-4 py-3 text-sm font-semibold text-gray-900">{sale.price} ★</td>
                                                    <td className="px-4 py-3">
                                                        {sale.sale_status ? (
                                                            <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-xs font-medium">
                                                                Active
                                                            </span>
                                                        ) : (
                                                            <span className="px-2 py-1 bg-red-100 text-red-700 rounded text-xs font-medium">
                                                                Inactive
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="px-4 py-3 text-xs text-gray-600">
                                                        {sale.start_sale ? (
                                                            <>
                                                                {new Date(sale.start_sale).toLocaleDateString()}<br/>
                                                                {new Date(sale.start_sale).toLocaleTimeString()}
                                                            </>
                                                        ) : (
                                                            'No start date'
                                                        )}
                                                    </td>
                                                    <td className="px-4 py-3 text-xs text-gray-600">
                                                        {new Date(sale.end_sale).toLocaleDateString()}<br/>
                                                        {new Date(sale.end_sale).toLocaleTimeString()}
                                                    </td>
                                                    <td className="px-4 py-3 text-sm font-semibold text-gray-900">
                                                        {sale.max_sales ? sale.max_sales : "Unlimited"}
                                                    </td>
                                                    <td className="px-4 py-3 text-sm font-semibold text-gray-900">{sale.nb_sold}</td>
                                                    <td className="px-4 py-3 text-sm text-gray-700 capitalize">{sale.target}</td>
                                                    <td className="px-4 py-3 text-sm font-bold text-blue-600">{sale.xp}</td>
                                                    <td className="px-4 py-3 text-center">
                                                        <div className="flex gap-2 justify-center">
                                                            <button 
                                                                onClick={() => window.location.href = `/admin/buds/sale/update/${this.state.bud_uuid}/${sale.bud_sale_uuid}`}
                                                                className="px-3 py-1 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors text-sm font-medium flex items-center gap-1"
                                                            >
                                                                <FaEdit size={12} />
                                                                Update
                                                            </button>
                                                            {sale.sale_status ? (
                                                                <button 
                                                                    onClick={() => this.toggleSaleStatus(sale)}
                                                                    className="px-3 py-1 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors text-sm font-medium flex items-center gap-1"
                                                                >
                                                                    <FaTimes size={12} />
                                                                    Deactivate
                                                                </button>
                                                            ) : (
                                                                <button 
                                                                    onClick={() => this.toggleSaleStatus(sale)}
                                                                    className="px-3 py-1 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors text-sm font-medium flex items-center gap-1"
                                                                >
                                                                    <FaCheck size={12} />
                                                                    Activate
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <p className="text-gray-500 text-center py-8">No sales configured yet</p>
                            )}

                            <button 
                                onClick={() => window.location.href = `/admin/buds/sale/new/${this.state.bud_uuid}`}
                                className="w-full px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                            >
                                <FaStore />
                                New Sale
                            </button>
                        </div>
                    </div>
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withRouter(AdminBudDetails)